import template from './workTeamList.html';
import controller from './workTeamList.controller';
import './workTeamList.scss';

let workTeamListComponent = {
  restrict: 'E',
  bindings: {
    employees: '<',
    filteredEmployees: '<',
    isMobileApp: '<',
    onCleanSearch:'&',
  },
  template,
  controller
};

export default workTeamListComponent;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/workTeamList/workTeamList.component.js